import { updateUrlFilterParams, clearedFilterOptions } from './helpers'

export const PRODUCT_FILTERS_UPDATED = 'PRODUCT_FILTERS_UPDATED'

/**
 * @typedef {Object} ProductFilters
 * @property {boolean} available - Will filter out any products that aren't in stock.
/*

/**
 * @param {ProductFilters} filters - Arbitrary set of filters to be updated.
 */
export const updateProductFilters = (filters) => {
  updateUrlFilterParams(filters)
  return {
    type: PRODUCT_FILTERS_UPDATED,
    filters,
  }
}

export const PRODUCT_FILTERS_CLEARED = 'PRODUCT_FILTERS_CLEARED'
export const clearProductFilters = () => {
  return {
    type: PRODUCT_FILTERS_CLEARED,
    filters: clearedFilterOptions,
  }
}
